// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackStartQuickOrderListUploadParameters extends TrackEventBaseParameters {}

const trackStartQuickOrderListUpload = (
    parameters: TrackStartQuickOrderListUploadParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "start_quick_order_list_upload", ...parameters }, options);
};

export default trackStartQuickOrderListUpload;
